import StandardField from '../StandardField';
import CuratedModuleField from '../StandardCuratedModuleField';

export default {

	props: ['field', 'fields'],

	data() {
		return {
			value: this.field,
		};
	},

	computed: {

		otherFields() {
			return this.fields.filter(field => field.id !== this.field.id);
		},

	},

	components: {
		StandardField,
	},

};
